import { z } from 'zod';

export const maintenanceSchema = z.object({
  enabled: z.boolean(),
  message: z.string().trim().max(280, 'Keep the banner under 280 characters.'),
});

export const currencyRateSchema = z.object({
  rate: z
    .number({ invalid_type_error: 'Enter a number' })
    .positive('Rate must be positive')
    .max(10, 'Rate seems unreasonably high')
    .refine((n) => Number.isFinite(n), 'Invalid number'),
});

export const generalSchema = z.object({
  default_city: z.string().trim().min(1, 'Pick a default city'),
  default_currency: z.enum(['ETB', 'USD']),
  contact_email: z.string().trim().email('Invalid email').or(z.literal('')),
  contact_phone: z
    .string()
    .trim()
    .max(40)
    .regex(/^[+\d\s\-()]*$/, 'Only digits, spaces and + - ( ) allowed')
    .or(z.literal('')),
});

export const featureFlagsSchema = z.record(z.boolean());

export type MaintenanceInput = z.infer<typeof maintenanceSchema>;
export type CurrencyRateInput = z.infer<typeof currencyRateSchema>;
export type GeneralInput = z.infer<typeof generalSchema>;
